(() => {
  const initialized = new WeakSet();

  function initSlider(slider) {
    if (!slider || initialized.has(slider)) return;
    initialized.add(slider);

    const slides = [...slider.querySelectorAll('[data-pmf-slide]')];
    const dots = [...slider.querySelectorAll('[data-pmf-dot]')];
    const prev = slider.querySelector('[data-pmf-prev]');
    const next = slider.querySelector('[data-pmf-next]');

    if (!slides.length) return;

    let current = 0;
    let timer = null;
    let touchStartX = 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Math.max(2000, Number(slider.dataset.interval || 4000));

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const stopAutoPlay = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAutoPlay = () => {
      if (!autoplay || reduceMotion || slides.length < 2 || window.Shopify?.designMode) return;
      stopAutoPlay();
      timer = window.setInterval(() => showSlide(current + 1), interval);
    };

    prev?.addEventListener('click', () => { showSlide(current - 1); startAutoPlay(); });
    next?.addEventListener('click', () => { showSlide(current + 1); startAutoPlay(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { showSlide(index); startAutoPlay(); }));

    slider.addEventListener('mouseenter', stopAutoPlay);
    slider.addEventListener('mouseleave', startAutoPlay);
    slider.addEventListener('focusin', stopAutoPlay);
    slider.addEventListener('focusout', startAutoPlay);
    slider.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 45) return;
      showSlide(delta < 0 ? current + 1 : current - 1);
      startAutoPlay();
    }, { passive: true });

    slider._pmfShowBlock = (blockId) => {
      const index = slides.findIndex((slide) => slide.dataset.pmfBlockId === blockId);
      if (index >= 0) {
        stopAutoPlay();
        showSlide(index);
      }
    };

    showSlide(0);
    startAutoPlay();
  }

  function initAll(root = document) {
    root.querySelectorAll?.('[data-pmf-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-pmf-slide]');
    const slider = event.target.closest?.('[data-pmf-slider]');
    if (slide && slider && slider._pmfShowBlock) slider._pmfShowBlock(slide.dataset.pmfBlockId);
  });
})();
